import React, { useState } from 'react';
import { Button, Divider, Form, Input, Select, Typography } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

const { Title } = Typography;

function Config(props) {

    const [ loading, setLoading ] = useState(false);

    async function onFinishHandler(values) {
        setLoading(true);
        await props.onSave(values);
        setLoading(false);
    }

    return (
        <>
            <Divider>
                <Title level={3}>Konfiguration</Title>
            </Divider>
            <Form
                name="config"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 18 }}
                onFinish={onFinishHandler}
                fields={[
                    {
                        name: ["title"],
                        value: props.title
                    },
                    {
                        name: ["type"],
                        value: props.type
                    },
                    {
                        name: ["mode"],
                        value: props.mode
                    }
                ]}
            >
                <Form.Item
                    label="Titel"
                    name="title"
                    rules={[
                    {
                        required: true,
                        message: "Bitte einen Titel eingeben!"
                    }
                    ]}
                >
                    <Input
                        placeholder="Bitte einen Titel eingeben, zum Beispiel: Anmeldung zum Gaupreisplattlen"
                    />
                </Form.Item>
                <Form.Item
                    label="Typ"
                    name="type"
                    rules={[
                    {
                        required: true,
                        message: "Bitte einen Typ wählen!"
                    }
                    ]}
                >
                    <Select
                        placeholder="Bitte einen Typ wählen!"
                    >
                        <Select.Option value="jugend">Jugend (AK 1 ... 3, Kindergruppen 1 ... 2)</Select.Option>
                        <Select.Option value="aktive">Aktive (AK 4 ... 8, Jugendgruppen, Aktive Gruppen)</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Modus"
                    name="mode"
                    rules={[
                    {
                        required: true,
                        message: "Bitte einen Modus wählen!"
                    }
                    ]}
                >
                    <Select
                        placeholder="Bitte einen Modus wählen!"
                    >
                        <Select.Option value="inactive">Inaktiv (Anmeldeformular wird nicht angezeigt)</Select.Option>
                        <Select.Option value="readonly">Nur lesend (Anmeldeformular ist nur lesend zugreifbar)</Select.Option>
                        <Select.Option value="active">Aktiv (Anmeldeformular ist vollständig aktiv)</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    wrapperCol={{ span: 24 }}
                    style={{ textAlign: "center" }}
                >
                    <Button
                        type="primary"
                        htmlType="submit"
                        icon={<SaveOutlined />}
                        loading={loading}
                    >
                        Konfiguration speichern
                    </Button>
                </Form.Item>
            </Form>  
        </>
    );
}

export default Config;